export default __webpack_public_path__ + "static/media/profileEmpty.92bf2ee3.jpg";